import packageInfo from '../../package.json';
import { libraryVersion, StandardAppConfig } from '@gaas/gaas-react-component-library';

const title = 'Toll Relief rebate';
const productCode = 'TollReliefRegistration';
const baseUrl = process.env['REACT_APP_API_URL'];
export const config: StandardAppConfig = {
    appTitle: title,
    apiKeys: {
        address: process.env.REACT_APP_NSWPOINT_V2_API_KEY!! || 'not-specified',
        abrLookup: process.env.REACT_APP_BIZ_PROFILE_API_KEY!! || 'not-specified'
    },
    businessSearchConfig: {
        // middle tier to proxy requests, and add auth headers
        authenticationGuid: null, // will be added by the gaas middle tier, using businessLookupGuid tas service prop
        baseUrl: baseUrl + '/api/col-abr-search-api',
        // use MOCK for local (see .env.development), default to COOKIE for real abr lookups
        authMode: process.env.REACT_APP_BUSINESS_SEARCH_AUTH_MODE || 'COOKIE',
        //authMode: 'COOKIE'
    },
    appConfig: {
        enabled: true,
        loaded: false,
        enableDebug: false,
        bypassFileUpload: false,
        profileConnectEnabled: true,
        environment: 'local',
        apigeeHost: 'none',
        globalNavConfig: {
            globalNavUrl: 'not-specified',
            globalNavUrlApiKey: 'not-specified',
            globalNavLinksUrl: 'not-specified',
            logoutUrl: process.env.REACT_APP_LOGOUT_URL!! || './logout'
        },
        allowImpactedAddress: true,
        clientIdentifiers: {
            // none defined by default (initialiseConfig may define some)
        }
    },
    // product config comes from the API for the product and may include flags that the ui can interpret
    // for eligibility rules
    productConfig: {
        enabled: true,
        loaded: false,
    },
    /* this is the base url of the web application */
    baseUrl: baseUrl || '',
    /* this is the base url of the apis for the web application (usually in the 'api' subfolder) */
    apiUrl: baseUrl + '/api',
    productCode: productCode,
    productTitle: title,
    projectArchetype: 'none',
    tutdSourceApplication: title,
    appRevision: packageInfo.version + (!!libraryVersion ? `; ui-lib: ${libraryVersion}` : ''),
    links: {
        // new tr3 t&c link
        termsAndConditionsLink: 'https://www.service.nsw.gov.au/terms-and-conditions/toll-relief-weekly-cap',
        // these are current tr2 t&c - might be updated ?
        tr2TermsAndConditionsPersonalLink: 'https://www.service.nsw.gov.au/terms-and-conditions/toll-relief-rebate-scheme',
        tr2TermsAndConditionsBusinessLink: 'https://www.service.nsw.gov.au/terms-and-conditions/toll-relief-rebate-scheme-sole-traders',
        privacyCollectionNoticeLink: 'https://www.service.nsw.gov.au/privacy-collection-notice/toll-relief-weekly-cap',
        productInformationLink: `https://www.service.nsw.gov.au/more-information/${productCode}`,
        logoutRedirectUrl: 'https://www.service.nsw.gov.au/?logoutSuccessful=true',
        tollTrackerUrl: process.env.REACT_APP_TOLL_TRACKER_URL || 'not-specified',
        personalEligibilityLink: 'https://www.service.nsw.gov.au/transaction/toll-relief-rebate-scheme#eligibility',
        soleTraderEligibilityLink:
            'https://www.service.nsw.gov.au/common-questions/toll-relief-rebate-scheme-sole-traders#eligibility',
        australianBusinessRegister: 'https://abr.business.gov.au/Help/UpdateABNDetails',
        eligibilityCriteria: 'https://www.service.nsw.gov.au/services/toll-relief',
        tollReliefLandingPage: 'https://www.service.nsw.gov.au/services/toll-relief',
        myAccountLoginPage: 'https://account.service.nsw.gov.au/',
        manageTollAccountPage: 'https://apply.service.nsw.gov.au/transaction/toll-relief-registration/manage-toll-account'
    },
    // The following sections enable overriding of default library copy and error messages
    helpMessages: {
        eligibilityPage: {
            directDamagesXXXX: 'Some custom message',
        },
    },
    errorMessages: {
        eligibilityPage: {
            directDamages: {
                required: 'You must answer the question about direct damages.'
            },
        },
    },
    placeholders: {},
    labels: {
        eligibilityPage: {
            directDamagesXXXX: 'Did you suffer direct damages in the event?'
        },
    },
// configure the session timeout component
    sessionTimeoutConfig: {
        timeoutIntervalInSeconds: 900,
        numberOfIntervals: 3
    },
//
};

export default config;
